import styles from "./button.module.scss";

export enum ButtonStyle {
	DARK = "dark",
	OUTLINE = "outline",
	WHITE = "white",
	LONG = "fullWidthBlack",
}

export enum ButtonRadius {
	NONE = "radiusNone",
	SM = "radiusSm",
	MD = "radiusMd",
	LG = "radiusLg",
	PILL = "radiusPill",
}

export enum ButtonSize {
	SM = "sizeSm",
	MD = "sizeMd",
	LG = "sizeLg",
}

export interface ButtonProps {
	title: string;
	onClick?: () => void;
	rightIcon?: React.ReactNode;
	leftIcon?: React.ReactNode;
	style?: ButtonStyle;
	radius?: ButtonRadius;
	size?: ButtonSize;
	type?: "submit" | "button";
	disbaled?: boolean;
}

const Button: React.FC<ButtonProps> = ({ title, onClick, rightIcon, leftIcon, disbaled, style = ButtonStyle.DARK, radius, size, type = "button" }) => {
	return (
		<button
			disabled={disbaled}
			type={type}
			onClick={onClick}
			className={`standardButton ${styles.submitButton} ${styles[style]} ${styles.button} ${radius ? styles[radius] : ""} ${size ? styles[size] : ""} ${disbaled ? styles.disableButton : ""}`.trim()}
		>
			{rightIcon} {title} {leftIcon}
		</button>
	);
};

export default Button;
